import { render } from "./RequestForm.vue?vue&type=template&id=7005b249&scoped=true"
import script from "./RequestForm.vue?vue&type=script&lang=js"
export * from "./RequestForm.vue?vue&type=script&lang=js"

import "./RequestForm.vue?vue&type=style&index=0&id=7005b249&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7005b249"]])

export default __exports__